export function slugify(text: string): string {
  return text
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function formatDate(dateStr: string): string {
  return new Date(dateStr).toLocaleDateString('en-GB', {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

export function formatTime(dateStr: string): string {
  return new Date(dateStr).toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatDateTime(dateStr: string): string {
  return `${formatDate(dateStr)} at ${formatTime(dateStr)}`;
}

export function classNames(...classes: (string | boolean | undefined | null)[]): string {
  return classes.filter(Boolean).join(' ');
}

export function getInitials(name: string): string {
  return name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
}

export const INSTRUMENT_OPTIONS = [
  'Lead Vocals', 'Backing Vocals', 'Lead Guitar', 'Rhythm Guitar', 'Acoustic Guitar',
  'Bass Guitar', 'Drums', 'Percussion', 'Keyboard', 'Piano', 'Organ', 'Synthesizer',
  'Saxophone', 'Trumpet', 'Trombone', 'Violin', 'Cello', 'Flute', 'Harmonica',
  'Banjo', 'Mandolin', 'Ukulele', 'DJ / Decks', 'Other',
];

export const GENRE_OPTIONS = [
  'Rock', 'Pop', 'Jazz', 'Blues', 'Country', 'Folk', 'Metal', 'Punk',
  'Indie', 'Electronic', 'Hip Hop', 'R&B', 'Soul', 'Funk', 'Reggae',
  'Classical', 'Latin', 'World', 'Alternative', 'Acoustic',
  'Singer-Songwriter', 'Cover Band', 'Tribute', 'Other',
];
